import { render } from "./DealMembersTable.vue?vue&type=template&id=543541e3&scoped=true"
import script from "./DealMembersTable.vue?vue&type=script&lang=js"
export * from "./DealMembersTable.vue?vue&type=script&lang=js"

import "./DealMembersTable.vue?vue&type=style&index=0&id=543541e3&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-543541e3"]])

export default __exports__